import type { MutableRefObject } from "react";
import type { IContactInfo } from "@checkout/index";

type UpdateContactInfoArgs = {
  callback?: (contactInfo: IContactInfo) => void;
  contactInfoRef: MutableRefObject<IContactInfo>;
  change: Partial<IContactInfo>;
};

export const updateContactInfo = ({
  callback,
  contactInfoRef,
  change,
}: UpdateContactInfoArgs) => {
  const contactInfo = {
    ...contactInfoRef.current,
    ...change,
  };

  contactInfoRef.current = contactInfo;
  callback?.(contactInfo);
};
